export const AUTOMATIC_CUSTOMER_MESSAGE_NAME_KEYS: Record<string, string> = {
  'tire_set-storage_end_reminder':
    'entity.automaticCustomerMessage.name.tire_set-storage_end_reminder',
  'business_case-reservation_confirmation':
    'entity.automaticCustomerMessage.name.business_case-reservation_confirmation',
  'business_case-reservation_expiring':
    'entity.automaticCustomerMessage.name.business_case-reservation_expiring',
  'business_case-online_offer_expiring':
    'entity.automaticCustomerMessage.name.business_case-online_offer_expiring',
  'business_case-deposit_payment_request':
    'entity.automaticCustomerMessage.name.business_case-deposit_payment_request',
  'business_case-deposit_received':
    'entity.automaticCustomerMessage.name.business_case-deposit_received',
  'business_case-balance_payment_request':
    'entity.automaticCustomerMessage.name.business_case-balance_payment_request',
  'business_case-payment_received':
    'entity.automaticCustomerMessage.name.business_case-payment_received',
  'business_case-payment_overdue_reminder':
    'entity.automaticCustomerMessage.name.business_case-payment_overdue_reminder',
  'business_case-contract_signed':
    'entity.automaticCustomerMessage.name.business_case-contract_signed',
  'complaint-received': 'entity.automaticCustomerMessage.name.complaint-received',
  'complaint-closed': 'entity.automaticCustomerMessage.name.complaint-closed',
  'test_drive-scheduled': 'entity.automaticCustomerMessage.name.test_drive-scheduled',
  'test_drive-reminder': 'entity.automaticCustomerMessage.name.test_drive-reminder',
  'interest-received': 'entity.automaticCustomerMessage.name.interest-received',
  'interest-no_response_follow_up':
    'entity.automaticCustomerMessage.name.interest-no_response_follow_up',
};
